/** Wide order page: `.content-column` scroll (footer), hidden scrollbar — see order-app.css. */
export function getOrderContentColumnScrollEl(): HTMLElement | null {
    return document.querySelector('#orderApp .main-content .content-column');
}

export function isOrderContentColumnAtScrollRest(): boolean {
    const column = getOrderContentColumnScrollEl();
    return !column || column.scrollTop < 2;
}

function wheelDeltaYPx(event: WheelEvent, scrollEl: HTMLElement): number {
    if (event.deltaMode === WheelEvent.DOM_DELTA_LINE) {
        const lineHeight = parseFloat(getComputedStyle(scrollEl).lineHeight) || 16;
        return event.deltaY * lineHeight;
    }
    if (event.deltaMode === WheelEvent.DOM_DELTA_PAGE) {
        return event.deltaY * scrollEl.clientHeight;
    }
    return event.deltaY;
}

function applyColumnWheelScroll(column: HTMLElement, deltaY: number): void {
    const maxScrollTop = column.scrollHeight - column.clientHeight;
    column.scrollTop = Math.max(0, Math.min(maxScrollTop, column.scrollTop + deltaY));
}

/**
 * When the meal list scrollport hits top/bottom, forward wheel deltas to the content column so the
 * user can reach the footer without a second visible scrollbar.
 */
export function bindOrderMealsScrollChaining(scrollport: HTMLElement): () => void {
    const onWheel = (event: WheelEvent): void => {
        const column = getOrderContentColumnScrollEl();
        if (!column) {
            return;
        }

        const { scrollTop, clientHeight, scrollHeight } = scrollport;
        if (scrollHeight <= clientHeight + 1) {
            return;
        }

        const atTop = scrollTop <= 1;
        const atBottom = scrollTop + clientHeight >= scrollHeight - 2;
        const deltaY = wheelDeltaYPx(event, scrollport);
        const scrollingDown = deltaY > 0;
        const scrollingUp = deltaY < 0;
        const columnMaxScrollTop = column.scrollHeight - column.clientHeight;

        if (scrollingDown && atBottom && column.scrollTop < columnMaxScrollTop - 0.5) {
            event.preventDefault();
            applyColumnWheelScroll(column, deltaY);
        } else if (scrollingUp && atTop && column.scrollTop > 0.5) {
            event.preventDefault();
            applyColumnWheelScroll(column, deltaY);
        }
    };

    scrollport.addEventListener('wheel', onWheel, { passive: false });
    return () => scrollport.removeEventListener('wheel', onWheel);
}
